var map = {
	"./4-active.svg": "5362",
	"./Face-01-Selected.svg": "4811",
	"./Face-01-Unselected.svg": "7914",
	"./Face-02-Selected.svg": "d7e0",
	"./Face-02-Unselected.svg": "c8e9",
	"./Face-03-Selected.svg": "71d7",
	"./Face-03-Unselected.svg": "62c6",
	"./Face-04-Selected.svg": "26e5",
	"./Face-04-Unselected.svg": "a4f8",
	"./Face-05-Selected.svg": "8443",
	"./Face-05-Unselected.svg": "8bab",
	"./No_Categories_No_Categories_Icon.svg": "513a",
	"./No_Products_No_Products_Icon.svg": "bd62",
	"./No_admins_icon.svg": "57ea",
	"./No_venues-01.svg": "0255",
	"./Spice_level_icon.svg": "ec87",
	"./arrow.svg": "b6e4",
	"./difference.svg": "4152",
	"./general.svg": "c220",
	"./good.svg": "9765",
	"./instagram.svg": "a3c9",
	"./power-by.svg": "6e82",
	"./very-bad.svg": "a4d8",
	"./well.svg": "bc51"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";